var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('vueper-slides',{attrs:{"fade":"","fixedHeight":"100vh","autoplay":"","progress":""}},_vm._l((_vm.slides),function(slide,i){return _c('vueper-slide',{key:i,attrs:{"image":slide.image,"title":slide.title,"content":slide.content}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }